export function compareTags({
  selectedTags,
  group
}: {
  selectedTags: string[] | null
  group: ScreenGroup | null
}) {
  const sameLength = group?.tags?.length === selectedTags?.length
  const sameValues =
    sameLength && group?.tags?.every(tag => selectedTags?.includes(tag))
  return sameValues
}

export function compareScreens({
  selectedScreens,
  group
}: {
  selectedScreens: ListScreensByTagsResponse[] | null
  group: ScreenGroup | null
}) {
  const sameLength = group?.screens?.length === selectedScreens?.length
  const sameValues =
    sameLength &&
    group?.screens?.every(screen =>
      selectedScreens?.some(s => s?.id === screen?.id)
    )
  return sameValues
}

export function hasSameTags({
  selectedTags,
  screenGroups
}: {
  selectedTags: string[] | null
  screenGroups: ScreenGroup[] | null
}) {
  const hasSelectedTags = selectedTags?.length > 0
  if (!hasSelectedTags || !screenGroups?.length) return false
  return screenGroups?.some(group => compareTags({ selectedTags, group }))
}

export function hasSameScreens({
  selectedScreens,
  screenGroups
}: {
  selectedScreens: ListScreensByTagsResponse[] | null
  screenGroups: ScreenGroup[] | null
}) {
  const hasSelectedScreens = selectedScreens?.length > 0
  if (!hasSelectedScreens || !screenGroups?.length) return false
  return screenGroups?.some(group => compareScreens({ selectedScreens, group }))
}

export function isDuplicate({
  selectedTags,
  selectedScreens,
  screenGroups
}: {
  selectedTags: string[] | null
  selectedScreens: ListScreensByTagsResponse[] | null
  screenGroups: ScreenGroup[] | null
}) {
  const hasSelectedTags = selectedTags?.length > 0
  const hasSelectedScreens = selectedScreens?.length > 0

  if (hasSelectedTags && hasSelectedScreens) {
    return (
      hasSameTags({ selectedTags, screenGroups }) &&
      hasSameScreens({ selectedScreens, screenGroups })
    )
  }
  return false
}

export function uniqueById(arr: ListScreensByTagsResponse[]) {
  return arr.reduce(
    (acc, current) =>
      acc.find(screen => screen?.id === current?.id) ? acc : [...acc, current],
    [] as ListScreensByTagsResponse[]
  )
}

export function hasNoChange({
  selectedTags,
  selectedScreens,
  group
}: {
  selectedTags: string[] | null
  selectedScreens: ListScreensByTagsResponse[] | null
  group: ScreenGroup | null
}) {
  return (
    compareTags({ selectedTags, group }) &&
    compareScreens({ selectedScreens, group })
  )
}

export function countSelectedFaces(screens: ListScreensByTagsResponse[] = []) {
  return screens?.reduce((acc, screen) => acc + (screen?.total_faces || 0), 0)
}
